import { FC } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import { OfferImageResponseDTO } from '../../../../type/dto/RequestResponseDTO';

interface OfferPositionImagesProps {
    images: OfferImageResponseDTO[];
    productName: string;
    onImageClick: (imageUrl: string) => void;
}

export const OfferPositionImages: FC<OfferPositionImagesProps> = ({
    images,
    productName,
    onImageClick
}) => {
    if (!images || images.length === 0) return null;

    return (
        <Box sx={{ mt: 1 }}>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
                <ImageIcon fontSize="small" sx={{ verticalAlign: 'middle', mr: 0.5, fontSize: '0.875rem' }} />
                {images.length} product image(s)
            </Typography>
            <Grid container spacing={0.5}>
                {images.map((img) => (
                    <Grid item key={img.id || img.uniqueId}>
                        <Box
                            component="img"
                            src={img.imageThumb || img.image}
                            alt={productName}
                            sx={{
                                width: 60,
                                height: 60,
                                objectFit: 'cover',
                                borderRadius: 1,
                                cursor: 'pointer',
                                border: '1px solid',
                                borderColor: 'divider',
                                '&:hover': {
                                    opacity: 0.8,
                                    borderColor: 'primary.main',
                                },
                            }}
                            onClick={() => onImageClick(img.image)}
                        />
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

